import { render, staticRenderFns } from "./SignedIn.vue?vue&type=template&id=23c4fdb1&scoped=true"
import script from "./SignedIn.vue?vue&type=script&lang=js"
export * from "./SignedIn.vue?vue&type=script&lang=js"
import style0 from "./SignedIn.vue?vue&type=style&index=0&id=23c4fdb1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4fdb1",
  null
  
)

export default component.exports